// src/api/pedidos.js
import api from "./config.js";

// Obtener todos los pedidos
    export const getPedidos = async () => {
    const { data } = await api.get("/pedidos");
    return Array.isArray(data) ? data : data.pedidos || [];
    };

    // Obtener un pedido por ID
    export const getPedido = async (id) => {
    const { data } = await api.get(`/pedidos/${id}`);
    return data;
    };

    // Crear un nuevo pedido
    export const createPedido = async (pedido) => {
    const { data } = await api.post("/pedidos", pedido);
    return data;
    };

    // Actualizar pedido
    export const updatePedido = async (id, pedido) => {
    const { data } = await api.put(`/pedidos/${id}`, pedido);
    return data;
    };

    // Eliminar pedido
    export const deletePedido = async (id) => {
    const { data } = await api.delete(`/pedidos/${id}`);
    return data;
    };
